import { IObjectsControllable } from "./IObjectsControllable";
import { ILinkedPageObjectSpecifiable } from "./ILinkedPageObjectSpecifiable";

export interface IEmptyAlertAllowBehaviorSpecifiable {
  emptyAlertAllowBehavior: IObjectsControllable<ILinkedPageObjectSpecifiable>;
}

export function instanceOfIEmptyAlertAllowBehaviorSpecifiable(instance: any): instance is IEmptyAlertAllowBehaviorSpecifiable {
  return instance
      && (instance.emptyAlertAllowBehavior !== undefined);
}
